// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/message/style/index.less
// module id = 1126
// module chunks = 1